export default {
  fullname: 'שם מלא',
  firstName: 'שם פרטי',
  lastName: 'שם משפחה',
  uid: 'תעודת זהות',
  familyStatus: 'מצב משפחתי',
  dob: 'תאריך לידה',
  gender: 'מין',
  spouse: 'שם בן / בת זוג',
  numberOfChildren: 'מספר ילדים',
  employeeType: 'סוג סוכן',
  email: 'דואר אלקטרוני',
  phone: 'טלפון',
  cellphone: 'נייד',
  extracellphone: 'נייד נוסף',
  website: 'אתר אנטרנט',
  homeaddress: 'כתובת מגורים',
  homephone: 'טלפון בית',
  officeaddress: 'כתובת משרד',
  officephone: 'טלפון משרד',
  policyend: 'תאריך תום פוליסה אחריות מקצועית',
  licenseend: 'תאריך תום רשיון',
  tax: 'תאריך ניכוי מס וניהול ספרים',
  license: 'תאריך תוקף רישיון סוכן',
  professionalPolicy: 'תאריך פוליסה מקצועית',
  clientNumber: 'מספר תיק/יישות',
  clientName: 'שם תיק/יישות',
  hp: 'ח.פ',
  headers: {
    private: 'פרטים אישיים',
    contact: 'פרטי קשר',
    home: 'בית',
    office: 'משרד',
    family: 'משפחה',
    dates: 'פרטים מנהליים',
  },
};
